
export const chatHistoryListGet = (data) => {
    return data.data;
}


export const followUpGet = (data) => {
    return data.data;
}

export const followUpPostGet = (data) => {
    return data.data;
}

